import type { TextOperationError, TextOperationResult } from '../../../domain';

/**
 * Thrown by `useTextOperationMutation` when the BE returns a TextOperationResult
 * with `status: 'Failed'` or `'Cancelled'`. The HTTP envelope says
 * `success: true` — `data.status` is the real signal. Parallels Image Lab's
 * OperationFailedError; carries the structured error for richer UI / retry.
 */
export class TextOperationFailedError extends Error {
  readonly result: TextOperationResult;
  readonly operationError: TextOperationError | null;
  readonly code: string;
  readonly retryable: boolean;

  constructor(result: TextOperationResult) {
    const message =
      result.error?.message?.trim() ||
      `Text operation ${result.status.toLowerCase()} without a message.`;
    super(message);
    this.name = 'TextOperationFailedError';
    this.result = result;
    this.operationError = result.error ?? null;
    this.code = result.error?.code ?? 'TEXT_OPERATION_FAILED';
    this.retryable = result.error?.retryable ?? false;
  }
}
